import React from "react"
import { useStrapiButtons } from "hooks/useStrapiButtons"
import { ButtonParser } from "components/button/ButtonParser"
import { Content } from "components/content/Content"
import { Image } from "components/image/Image"
import type { SingleContentBlock } from "./multi-content-block"
import "./multi-content-block.module.scss"

interface MultiContentBlockProps extends Omit<SingleContentBlock, "id"> {}

export const MultiContentBlock = ({
  buttons,
  heading,
  image,
  reusable_button_group,
  sub_heading,
  text,
}: MultiContentBlockProps) => {
  const strapiButtons = useStrapiButtons(buttons, reusable_button_group)

  return (
    <div className="MCB">
      {image && (
        <Image
          alt={image.alternativeText ?? ""}
          className="MCB__image"
          image={{ ...image, width: 652 }}
        />
      )}
      {heading && <h4 className="MCB__heading">{heading}</h4>}
      {sub_heading && <h5 className="MCB__sub-heading">{sub_heading}</h5>}
      {text && text?.data?.text && text?.data?.text !== "<p></p>" && (
        <div className="MCB__content">
          <Content content={text.data?.text} styleListsAsGrid={false} />
        </div>
      )}
      {!!strapiButtons?.length && (
        <div className="MCB__cta-container">
          <ButtonParser
            buttons={[strapiButtons[0]]}
            extraClassNames="MCB__cta"
            navigationColorVariantSolid="solid-secondary"
            navigationColorVariantOutline="outline-secondary"
            ctaColorVariantSolid="solid-secondary"
            ctaColorVariantOutline="outline-secondary"
          />
        </div>
      )}
    </div>
  )
}
